







import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class Ctas extends Vue {
    @Prop() public step!: number

    // public callBTN = false
    // Ajoute un evenement "OnClick" sur le bouton pour passer a la vue suivante...
    private addEventInBtn () : void {
      const btn = document.querySelector('.next-btn-tunnel')
      if (btn) {
        btn.addEventListener('click', (event) => {
          if (event) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            this.nextStep()
          }
        }, false)
      }
    }

    private addEventInFakeBtn () : void {
      const fakebtn = document.querySelector('.fake-btn')
      const forminfo = document.querySelector('.form-info')
      if (fakebtn) {
        fakebtn.addEventListener('click', (event) => {
          if (event) {
            forminfo.style.display = "block";
          }
        }, false)
      }
    }

    

    // On cherche le getters correspondant à la vue courante
    private getGetterVueX (step: number): string {
      const current = Object.keys(this.$store.getters).filter((el:unknown) => el === 'getValueForStep' + step.toString())
      // console.log('current : ' + this.$store.getters)
      return this.$store.getters[current[0]]
    }

    // Passe a la vue suivant si la valeur de la vue actuelle à bien été enregistrée
    private nextStep () : void {
      const getterResult = this.getGetterVueX(this.step)
      const btn = document.querySelector('.next-btn-tunnel')
      if (getterResult !== '') {
        switch (this.step) {
          case 1:
            // On envoie a la vue suivante
            this.$router.push({ name: 'Etape2' })
            break
          case 2:
          // console.log(getterResult)
            // On envoie a la vue suivante
            this.$router.push({ name: 'Etape3' })
            break
          case 3:
            // On envoie a la vue suivante
            this.$router.push({ name: 'Etape4' })
            break
          case 4:
            // On envoie a la vue suivante
            this.$router.push({ name: 'Etape5' })
            break
          case 5:
            this.$router.push({ name: 'EtapeForm' })
            break
          default:
            break
        }
      }
    }

    mounted (): void {
      this.addEventInBtn()
      this.addEventInFakeBtn()
    }
}
